import { render, staticRenderFns } from "./TaxDeleteForm.vue?vue&type=template&id=5842916c&"
import script from "./TaxDeleteForm.vue?vue&type=script&lang=ts&"
export * from "./TaxDeleteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports